var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('video',{ref:"videoPlayer",staticClass:"video-js vjs-big-play-button",attrs:{"options":_vm.options,"data-setup":"{\"fluid\": true}"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }